import type { DiscoveryV2ListResponseType } from "@sellar-io/api-v2/types";
import { useDiscoveryV2ProductList } from "./useDiscoveryV2ProductList";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";

const SPIRIT_KEYWORDS = [
  "gin",
  "rum",
  "whiskey",
  "whisky",
  "vodka",
  "tequila",
] as const;

const SPIRITS_SEARCH_STRING = `(${SPIRIT_KEYWORDS.join("|")})`;

export const useDiscoverySpiritsProducts = ({
  limit = 15,
  enabled = true,
}: {
  limit?: number;
  enabled?: boolean;
} = {}) => {
  const { business } = useSellarCurrentBusiness();
  const buyerPostcode = business?.DeliveryAddress.postalCode;

  const query = useDiscoveryV2ProductList<DiscoveryV2ListResponseType>(
    {
      limit,
      search: SPIRITS_SEARCH_STRING,
      sortBy: "random",
      retailerPostcode: buyerPostcode,
      query: [
        {
          type: "inStockItemsOnly",
          modifier: "EQUALS",
          value: true,
        },
        {
          type: "deliveredBySellar",
          modifier: "EQUALS",
          value: true,
        },
      ],
    },
    {
      enabled: enabled && !!buyerPostcode,
    },
  );

  const products = query.data?.pages.flat() ?? [];

  return {
    ...query,
    products,
  };
};
